import {
    QuestionCircleOutlined,
    FontColorsOutlined,
  } from '@ant-design/icons';
  import { APP_PREFIX_PATH } from 'configs/AppConfig'
  import factura from '../../menus/icons/factura.js'
  import emisor from '../../menus/icons/emisor.js'
let AdminModuloEcommerce = [
  {
    key: "Ecommerce",
    path: `${APP_PREFIX_PATH}/`,
    title: "sidenav.ecommerce.ecommerce",
    icon: QuestionCircleOutlined,
    breadcrumb: true,
    submenu: [
      {
        key: "ecommerce",
        path: `${APP_PREFIX_PATH}/admin/ecommerce`,
        title: "sidenav.ecommerce.vender",
        icon: factura,
        breadcrumb: true,
        submenu: [
          {
            key: "ecommerceOfertas",
            path: `${APP_PREFIX_PATH}/admin/ecommerce/ofertas`,
            title: "sidenav.ecommerce.ofertas",
            icon: emisor,
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "cupones",
            path: `${APP_PREFIX_PATH}/admin/facturacion/cupones`,
            title: "sidenav.ecommerce.cupones",
            icon: FontColorsOutlined,
            breadcrumb: true,
            submenu: [],
          },
        ],
      },
      {
        key: "ventas",
        path: `${APP_PREFIX_PATH}/admin/ecommerce/ventas`,
        title: "sidenav.ecommerce.ventas",
        icon: factura,
        breadcrumb: true,
        submenu: [],
      },
    ],
  },
];

export default AdminModuloEcommerce;
